import { requirePermission } from '@/utils/filter';
import { userStore } from '@/store';
import { OPERATION_PERMISSIONS } from '@/configs/enums/permissions';

/**
 * クレジットカード登録が可能かどうか
 */
export const canAccessPaymentCardCreate = (): boolean => {
  // 1. 基本料金課金対象チェック
  if (!userStore.isCompanyChargeTarget) {
    console.error('基本料金課金が無効です');

    return false;
  }

  // 2. COMPANY_SETTING_PAYMENT_WRITE 権限チェック
  if (!requirePermission([OPERATION_PERMISSIONS.COMPANY_SETTING_PAYMENT_WRITE])) {
    console.error('COMPANY_SETTING_PAYMENT_WRITE 権限がありません');

    return false;
  }

  return true;
};
